import React, { useState, useEffect } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { globals as globalsSlice } from '../../../../app/globalsSlice';
import PageTitleBreadcrumb from '../../../../components/PageTitleBreadcrumb';
import { t } from '../../../../providers';
import { me as meSlice } from '../../../AuthenticatedPage/authenticationSlice';
import { SLICE_NAME } from '../../constants';
import { list, loading as loadingSlice, error as errorSlice } from '../../onlineServicesSlice';
import FieldsMissingDialog from '../../../MyAccountPage/components/ChildAccounts/FieldsMissingDialog';
import NoRedirectServiceDialog from '../NoRedirectServiceDialog';
import SearchFilter from '../SearchFilter';
import ServicesCatalogue from '../ServicesCatalogue';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Select from '@material-ui/core/Select';
import { ReactComponent as DropDownArrow } from '../../../../assets/images/unfold_more_24px.svg';
import MenuItem from '@material-ui/core/MenuItem';

import { getLocale } from '../../../../providers';

import IconButton from '@material-ui/core/IconButton';
import ErrorHandler from '../../../../common/components/ErrorHandler';
import { ReactComponent as RefreshIcon } from '../../../../assets/images/refresh_icon.svg';
import PageTitle from '../../../../components/PageTitle';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
    tabs: {
        '& .MuiTabs-scroller::-webkit-scrollbar-thumb': {
            backgroundColor: 'unset',
        },
        '@media (max-width:600px)': {
            marginTop: '25px',
        },
        '& .MuiTab-root': {
            minWidth: '100px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
            '@media (max-width:600px)': {
                minWidth: '120px',
            },
            '@media (max-width:400px)': {
                minWidth: '70px',
            },
        },
    },
    tabContainer: {
        width: '100%',
    },
    profileTabContainer: {
        '@media (min-width:1100px)': {
            // width: '653px',
        },
    },
    textInput: {
        height: '2rem',
        width: '160px',
        borderRadius: '4px',
        marginBottom: '10px',
        border: '1px solid #B1B1B1',
        background: '#fff',
        '& svg': {
            width: '35px',
        },
        '& .MuiSelect-select': {
            '&:focus-visible': {
                borderColor: '#9b9b9b',
            },
            paddingRight: 0,
        },
        '@media (max-width:600px)': {
            width: '9.5rem',
        },
    },
    searchRow: {
        marginTop: '24px',
    },
    refreshButton: {
        color: '#3F5E20',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '16px',
        letterSpacing: '0.5px',
        textAlign: 'left',
        padding: '0px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    disabledMenuItem: {
        color: '#5D5D5D',
        opacity: '1 !important',
    },
    onlineServiceTitle: {
        marginTop: '-32px',
    },
    focusedElement: {
        backgroundColor: 'rgba(209, 224, 194, 0.2)',
        outline: 'none',
        border: '2px dashed #4F7E1D',
        borderRadius: '3px',
    },
}));

const ALL = 'all';
const FAVORITES = 'favorites';
const modalServices = ['0543', '0588', '5488'];

const AllTrademarkPage = () => {
    const classes = useStyles();
    const service = 'trademark';
    const location = useLocation();
    const history = useHistory();
    const me = useSelector(meSlice);
    const dispatch = useDispatch();
    const loading = useSelector(loadingSlice);
    const error = useSelector(errorSlice);
    const servicesList = useSelector(list);
    const { globals } = useSelector(globalsSlice) || {};

    const [tabs, setTabs] = useState([]);
    const routeTab = location.pathname.split('/')[3];
    const [selectedTab, setSelectedTab] = useState(routeTab === 'all' ? 0 : 1);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [serviceDialogOpen, setServiceDialogOpen] = useState(false);
    const [sortOrder, setSortOrder] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [itemsToSend, setItemsToSend] = useState([]);
    const [errorHandler, setErrorHandler] = useState({ hasRefresh: false, message: '', subtitle: '' });
    const [selectIsOpen, setSelectIsOpen] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    let firstLoad = true;

    useEffect(() => {
        if (error && error !== null && error.extraInfo) {
            setErrorHandler({ message: error.message, hasRefresh: error.extraInfo.hasRefresh, subtitle: error.extraInfo.secondMessage });
            if (error.details) {
                const onlineServicesList = error.details.favorites && error.details.favorites !== null ? JSON.parse(error.details.favorites) : [];
                parseOnlineServicesList({ favoriteData: onlineServicesList });
            }
        }
    }, [error]);

    const navigateTo = (event, path) => {
        event.preventDefault();
        const selectedLanguage = getLocale();

        if (path) {
            const noRedirectService = modalServices.indexOf(path.split('.')[2]) >= 0;
            if (noRedirectService) {
                setServiceDialogOpen(true);
            } else {
                let newPath = `${globals.ipo['fo.url']}${globals.ipo[path]}`;
                if (newPath.indexOf('?') >= 0) {
                    newPath += `&lang=${selectedLanguage}`;
                } else {
                    newPath += `?lang=${selectedLanguage}`;
                }
                if (!!newPath) window.open(newPath, '_blank');
            }
        } else {
            if (path && location.pathname !== path) {
                history.push(path);
            }
        }
    };

    const navigateToProfile = (event) => {
        event.preventDefault();
        setDialogOpen(false);
        history.push('/my-account/profile-details');
    };

    const cancelMessage = (event) => {
        event.preventDefault();
        setDialogOpen(false);
    };

    const cancelServiceMessage = (event) => {
        event.preventDefault();
        setServiceDialogOpen(false);
    };

    const search = (query) => {
        const trimmedQuery = query.trim();

        if (trimmedQuery.length > 2) {
            setSearchTerm({ ...searchTerm, searchQuery: query });
        }
    };

    const clearSearch = () => {
        setSearchQuery('');
        setSearchTerm('');
    };

    const handleTabChange = (event, value) => {
        event.preventDefault();
        clearSearch();
        if (value === 0) {
            history.push(`/online-services/${service}/all`);
        } else {
            history.push(`/online-services/${service}/favourites`);
        }
    };

    const handleSortChange = (event) => {
        firstLoad = false;
        const value = event.target.value;
        if (sortOrder === value) return;
        setSortOrder(value);
        sortItems();
    };

    const handleEnterKey = (item) => {
        setSelectedService(`starBtn-${item.title}`);
    };

    const handleFavoriteToggle = (item) => {
        const toggleFavorite = { ...item };
        toggleFavorite.favorite = !item.favorite;

        const params = {
            requestBody: { favoriteData: [{ ...toggleFavorite }] },
            applicationType: service,
            isFavoritesPage: tabs[selectedTab] === 'favorites',
        };
        dispatch({ type: `${SLICE_NAME}/requestUpdateFavoriteOnlineServices`, payload: { params } });
    };

    const sortItems = () => {
        let sortedList = itemsToSend.sort((a, b) => {
            if (sortOrder) {
                return t(a.title) < t(b.title) ? 1 : -1;
            } else {
                return t(a.title) > t(b.title) ? 1 : -1;
            }
        });
        setItemsToSend(sortedList);
    };

    useEffect(() => {
        if (selectedService) {
            const selectedServiceBtn = document.getElementById(selectedService);
            if (selectedServiceBtn) {
                selectedServiceBtn.focus();
                selectedServiceBtn.classList.add(classes.focusedElement);
            }
            setSelectedService(null);
        }
    }, [itemsToSend]);

    // filter e-services items based on tab selection
    useEffect(() => {
        const allowedTabs = [ALL, FAVORITES];

        if (allowedTabs.length > 0) {
            setTabs(allowedTabs);
        } else {
            history.push('/');
        }
    }, [me, history]);

    useEffect(() => {
        if (tabs.length > 0 && !loading) {
            requestOnlineServices();
        }
    }, [dispatch, tabs, selectedTab]);

    const requestOnlineServices = () => {
        setErrorHandler({ hasRefresh: false, message: '', subtitle: '' });
        const params = {
            selectedTab: tabs[selectedTab],
            applicationType: service,
        };
        dispatch({ type: `${SLICE_NAME}/requestOnlineServices`, payload: { params } });
    };

    useEffect(() => {
        if (tabs.length > 0) {
            if (servicesList) {
                parseOnlineServicesList(servicesList);
            } else if (error && error !== null && error.details && error.details.favorites && !!error.details.favorites.length) {
                parseOnlineServicesList({ favoriteData: JSON.parse(error.details.favorites) });
            }
        }
    }, [servicesList, tabs, selectedTab, searchTerm]);

    const parseOnlineServicesList = (servicesList) => {
        let availableServices = servicesList.favoriteData.slice().sort((a, b) => {
            if ((firstLoad && sortOrder) || sortOrder) {
                return t(a.title) > t(b.title) ? 1 : -1;
            } else {
                return t(a.title) < t(b.title) ? 1 : -1;
            }
        });
        if (searchTerm !== '') {
            if (searchTerm.searchQuery && searchTerm.searchQuery !== '') {
                availableServices = availableServices.filter((item) => t(item.title).toLowerCase().includes(searchTerm.searchQuery.toLowerCase()));
            }
        }

        setItemsToSend(availableServices);
    };

    const sortList = [
        {
            label: t('sort.order.asc'),
            value: true,
        },
        {
            label: t('sort.order.desc'),
            value: false,
        },
    ];

    return (
        <div>
            <PageTitle title={t('online.services.title')} details={''} />
            <div className={classes.onlineServiceTitle}>
                <PageTitleBreadcrumb
                    parentTitle={t('online.services.title')}
                    parentLink={`/online-services/${service}`}
                    title={t('trademarks')}
                    details={t(service + '.description')}
                    subLink={`/online-services/${service}`}
                    subTitle={tabs[selectedTab] === 'all' ? t(service + '.all') : t('favorites.tab.title.text')}
                />
            </div>

            <Tabs className={classes.tabs} value={selectedTab} onChange={handleTabChange} textColor="primary" aria-label={t('online.services.title')}>
                {tabs.map((tab, index) => (
                    <Tab
                        disableFocusRipple
                        id={`tab-${tab}-${index}`}
                        key={`tab-${index}`}
                        label={t(tab + '.tab.title')}
                        style={{ textTransform: 'uppercase' }}
                        aria-selected={selectedTab === index ? 'true' : 'false'}
                        aria-controls={`online-services-trademark-tabpanel-${index}`}
                        role="tab"
                    />
                ))}
            </Tabs>

            <div className={classes.searchRow} role="search">
                <SearchFilter onSearch={search} searchQuery={searchQuery} onClear={clearSearch} searchFilterLabelText={'search.tm.services'} />
            </div>
            <div className={classes.searchRow} style={{ paddingBottom: '10px' }}>
                <Select
                    onOpen={() => setSelectIsOpen(true)}
                    onClose={() => setSelectIsOpen(false)}
                    SelectDisplayProps={{
                        'aria-label': `${t('select.sort.label')}`,
                        role: 'combobox',
                        'aria-controls': 'sorting-options',
                        'aria-expanded': selectIsOpen,
                        'aria-labelledby': undefined,
                    }}
                    id="sort-select"
                    className={classes.textInput}
                    displayEmpty
                    label={t('select.sort.label')}
                    onChange={handleSortChange}
                    value={sortOrder}
                    IconComponent={() => <DropDownArrow aria-hidden="true" focusable="false" />}
                    inputProps={{ 'aria-haspopup': 'listbox' }}
                    MenuProps={{ MenuListProps: { id: 'sorting-options', role: 'listbox', 'aria-labelledby': 'sort-select' } }}>
                    {sortList.map(({ key, value, label }, idx) => (
                        <MenuItem
                            role="option"
                            aria-label={`${t('select.sort.label')}: ${label}`}
                            aria-selected={sortOrder === value}
                            key={`${key}_${idx}`}
                            value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </Select>
            </div>
            {errorHandler.message !== '' && (
                <ErrorHandler
                    title={errorHandler.message}
                    subtitle={errorHandler.subtitle}
                    action={
                        errorHandler.hasRefresh && (
                            <IconButton
                                disableFocusRipple
                                className={classes.refreshButton}
                                onClick={() => {
                                    requestOnlineServices();
                                }}>
                                {t('refresh.button.text')}
                                <RefreshIcon style={{ paddingLeft: '6.68px' }} aria-hidden="true" focusable="false" />
                            </IconButton>
                        )
                    }
                />
            )}
            {globals && !loading ? (
                <div
                    className={classes.profileTabContainer}
                    id={`online-services-trademark-tabpanel-${selectedTab}`}
                    aria-labelledby={`tab-${tabs[selectedTab]}-${selectedTab}`}
                    role="tabpanel">
                    {!loading && (
                        <ServicesCatalogue
                            items={itemsToSend}
                            navigateTo={navigateTo}
                            toggleFavorites={handleFavoriteToggle}
                            handleEnterKey={handleEnterKey}
                        />
                    )}
                </div>
            ) : (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress aria-hidden="true" />
                    <Typography variant="srOnly" role="alert">
                        {t('loading.text')}
                    </Typography>
                </div>
            )}
            <FieldsMissingDialog open={dialogOpen} onAccept={navigateToProfile} onCancel={cancelMessage} />
            <NoRedirectServiceDialog open={serviceDialogOpen} onAccept={cancelServiceMessage} />
        </div>
    );
};

export default AllTrademarkPage;
